import { render } from "./ContadorTarifas.vue?vue&type=template&id=3edd3972&scoped=true"
import script from "./ContadorTarifas.vue?vue&type=script&lang=js"
export * from "./ContadorTarifas.vue?vue&type=script&lang=js"

import "./ContadorTarifas.vue?vue&type=style&index=0&id=3edd3972&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\Public\\frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3edd3972"]])

export default __exports__